var _style, _path, _path2, _rect, _rect2, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon0, _polygon1, _polygon10, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUz(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 42",
    style: {
      enableBackground: "new 0 0 64 42"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0093AE;}\n\t.st1{fill:#1DB038;}\n\t.st2{fill:#CE1126;}\n\t.st3{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rounded_Rectangle_7_copy",
    className: "st0",
    d: "M5.8,0h52.3C61.4,0,64,2.6,64,5.7v30.6c0,3.2-2.6,5.7-5.8,5.7H5.8 C2.6,42,0,39.4,0,36.3V5.7C0,2.6,2.6,0,5.8,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,36.3C0,39.4,2.6,42,5.8,42h52.4c3.2,0,5.8-2.5,5.8-5.7V23.5H0V36.3z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 12.6,
    className: "st2",
    width: 64,
    height: 16.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 14,
    className: "st3",
    width: 64,
    height: 14
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "29,9.3 29.2,10.1 30,10.1 29.4,10.5 29.6,11.3 29,10.8 28.3,11.3 28.6,10.5 28,10.1 28.7,10.1 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "29,5.6 29.2,6.4 30,6.4 29.4,6.8 29.6,7.6 29,7.1 28.3,7.6 28.6,6.8 28,6.4 28.7,6.4 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "29,1.9 29.2,2.7 30,2.7 29.4,3.1 29.6,3.8 29,3.4 28.3,3.8 28.6,3.1 28,2.7 28.7,2.7 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "21,9.3 21.2,10.1 22,10.1 21.4,10.5 21.6,11.3 21,10.8 20.3,11.3 20.6,10.5 20,10.1 20.7,10.1 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "21,5.6 21.2,6.4 22,6.4 21.4,6.8 21.6,7.6 21,7.1 20.3,7.6 20.6,6.8 20,6.4 20.7,6.4 "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "21,1.9 21.2,2.7 22,2.7 21.4,3.1 21.6,3.8 21,3.4 20.3,3.8 20.6,3.1 20,2.7 20.7,2.7 "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "17,9.3 17.2,10.1 18,10.1 17.4,10.5 17.6,11.3 17,10.8 16.3,11.3 16.6,10.5 16,10.1 16.7,10.1 "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "17,5.6 17.2,6.4 18,6.4 17.4,6.8 17.6,7.6 17,7.1 16.3,7.6 16.6,6.8 16,6.4 16.7,6.4 "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "13,9.3 13.2,10.1 14,10.1 13.4,10.5 13.6,11.3 13,10.8 12.3,11.3 12.6,10.5 12,10.1 12.7,10.1 "
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "25,9.3 25.2,10.1 26,10.1 25.4,10.5 25.6,11.3 25,10.8 24.3,11.3 24.6,10.5 24,10.1 24.7,10.1 "
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "25,5.6 25.2,6.4 26,6.4 25.4,6.8 25.6,7.6 25,7.1 24.3,7.6 24.6,6.8 24,6.4 24.7,6.4 "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "25,1.9 25.2,2.7 26,2.7 25.4,3.1 25.6,3.8 25,3.4 24.3,3.8 24.6,3.1 24,2.7 24.7,2.7 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M5.4,6.6c0-2.3,1.7-4.2,3.9-4.6C9,2,8.8,2,8.5,2C6,2,3.9,4.1,3.9,6.6s2.1,4.6,4.6,4.6c0.3,0,0.5,0,0.8-0.1 C7.1,10.8,5.4,8.9,5.4,6.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUz);
export default __webpack_public_path__ + "static/media/uz.58de6df91fd8d89a08f9bca016b917a1.svg";
export { ForwardRef as ReactComponent };